/**
 * Identifiers for Ekho Wedge Products — the self-serve product catalog.
 *
 * These IDs are the canonical keys used in:
 * - Stripe Price map (billing.service.ts)
 * - Frontend product catalog (productCatalog.ts)
 * - Product config mapping (PRODUCT_CONFIG_MAP)
 * - Onboarding & subscription flows
 *
 * Usage: `WedgeProduct.AI_BDC` → `'ai-bdc'`
 */
const WedgeProduct = {
    AI_BDC: 'ai-bdc',
    AI_WEBSITE: 'ai-website',
    VOICE_SERVICE: 'voice-service',
    ONLINE_CHECKOUT: 'online-checkout',
    IMAGE_ENHANCEMENT: 'image-enhancement',
    THREE_SIXTY_VIEWER: '360-viewer',
    OUTBOUND_VOICE: 'outbound-voice',
    CREDIT_APP_FILL: 'credit-app-fill',
    AI_CRM: 'ai-crm',
};

export { WedgeProduct };
//# sourceMappingURL=WedgeProduct.js.map
